import React from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";

import "./style.css";
const PieChart = ({ chartData, text }) => {
  const options = {
    tooltips: { enabled: false },
    hover: { mode: null },
  };
  return (
    <>
      <div className="chart-outer">
        <Doughnut data={chartData} options={options} />
        <div className="inner-text">{text}</div>
      </div>
    </>
  );
};

export default PieChart;
